import React from 'react';
import { Users, BookCopy, Star, Globe } from 'lucide-react';
export function SocialProofBar() {
  return <div className="bg-[#0c0d14] text-gray-400 py-1.5 px-2 border-y border-white/5 relative z-20" data-id="element-188">
      <div className="max-w-4xl mx-auto flex flex-wrap justify-center items-center gap-x-3 gap-y-1 text-[9px] md:text-[11px] font-medium text-center uppercase tracking-tight" data-id="element-189">
        <div className="flex items-center" data-id="element-190">
          <Users className="w-3 h-3 mr-1 text-gray-400" data-id="element-191" />
          <span data-id="element-192">+2.500 docentes confían</span>
        </div>
        <span className="hidden md:inline text-white/15" data-id="element-193">|</span>
        <div className="flex items-center" data-id="element-194">
          <BookCopy className="w-3 h-3 mr-1 text-gray-400" data-id="element-195" />
          <span data-id="element-196">6 tomos premium + 4 bonos</span>
        </div>
        <span className="hidden md:inline text-white/15" data-id="element-197">|</span>
        <div className="flex items-center" data-id="element-198">
          <Star className="w-3 h-3 mr-1 text-brand-gold fill-current" data-id="element-199" />
          <span data-id="element-200">4,9/5 calificación</span>
        </div>
        <span className="hidden md:inline text-white/15" data-id="element-201">|</span>
        <div className="flex items-center" data-id="element-202">
          <Globe className="w-3 h-3 mr-1 text-gray-400" data-id="element-203" />
          <span data-id="element-204">Todo el mundo hispanohablante</span>
        </div>
      </div>
    </div>;
}